import { IconsProps } from './IconsProps';

const Phone = ({
  className = '',
  viewBox = '0 0 16 16',
  width = 16,
  height = 16,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path d="M10.6637 9.06069C10.3554 9.51519 9.98814 9.92776 9.57118 10.2879C9.55758 10.2884 9.54399 10.2889 9.52309 10.2891C9.22201 10.2615 8.9304 10.1705 8.66789 10.0223C8.65446 10.0164 8.64118 10.0107 8.62112 10.0021C7.6732 9.56508 6.84746 8.9064 6.21541 8.08313C5.99322 7.83973 5.82309 7.55451 5.71523 7.24459C5.88727 6.75278 6.54495 6.45721 6.54981 5.90561C6.55017 5.85383 6.54521 5.80217 6.53501 5.75139C6.18335 5.06113 5.88984 4.34244 5.58879 3.62915C5.57207 3.62703 5.55565 3.62479 5.539 3.62267C5.29967 3.58331 5.0578 3.56088 4.81524 3.55554C4.73881 3.55633 4.66251 3.56174 4.58676 3.57177C4.22126 3.63375 3.97009 3.93727 3.6944 4.15815C3.37097 4.5867 3.17224 5.09438 3.11972 5.62635C3.11465 5.69014 3.11176 5.75301 3.11108 5.8159C3.15882 6.63757 3.45617 7.426 3.96433 8.0783C4.79826 9.25954 5.83676 10.2861 7.03204 11.1108C7.88406 11.6422 8.81216 12.0439 9.78518 12.3027C10.1299 12.3996 10.4869 12.4473 10.8453 12.4443C11.5203 12.4462 12.1757 12.2194 12.702 11.8019C13.2418 11.4417 13.3292 10.7581 13.3333 10.1644V10.0924C13.0219 9.93964 12.7096 9.7879 12.3944 9.64408C11.8542 9.35627 11.2693 9.15911 10.6637 9.06069Z" />
    </svg>
  );
};

export default Phone;
